export default __webpack_public_path__ + "960a7546e08ed71c68bef040894c5d79.png";